const UA = window.navigator.userAgent || '';
const QB_PACKAGE_NAME = 'com.tencent.mtt';
const defaultMarketSchemeUrl = `market://details?id=${QB_PACKAGE_NAME}`;
const MarketType = {};
MarketType['DEFAULT'] = 'DEFAULT';
MarketType['HUAWEI'] = 'HUAWEI';
MarketType['HONOR'] = 'HONOR';
MarketType['OPPO'] = 'OPPO';
MarketType['VIVO'] = 'VIVO';
MarketType['SAMSUNG'] = 'SAMSUNG';
MarketType['XIAOMI'] = 'XIAOMI';
MarketType['REALME'] = 'REALME';
MarketType['LENOVO'] = 'LENOVO';
MarketType['MEIZU'] = 'MEIZU';
MarketType['YYB'] = 'YYB';
const MARKET_SCHEME_MAP = {
  [MarketType.DEFAULT]: defaultMarketSchemeUrl,
  [MarketType.OPPO]: defaultMarketSchemeUrl,
  [MarketType.REALME]: defaultMarketSchemeUrl,
  [MarketType.HUAWEI]:
    'hiapplink://com.huawei.appmarket?appId=C20679&channelId=%E5%BE%AE%E4%BF%A1%E6%96%B0%E9%97%BB%E6%8F%92%E4%BB%B6&id=c1eaa99d28124d13a97a345db543a9e9&s=A2F7EB0008BC2AEBEE6E0C737DD3B8254C36BE76F157CDF873FB7DA92ADCF0A1&detailType=0&v=&callType=AGDLINK&installType=0000',
  [MarketType.HONOR]: `honormarket://details?id=${QB_PACKAGE_NAME}`,
  [MarketType.VIVO]: `vivoMarket://details?id=${QB_PACKAGE_NAME}`,
  [MarketType.SAMSUNG]: `samsungapps://ProductDetail/${QB_PACKAGE_NAME}`,
  [MarketType.XIAOMI]: `mimarket://details?id=${QB_PACKAGE_NAME}`,
  [MarketType.MEIZU]: `mstore://details?package_name=${QB_PACKAGE_NAME}`,
  [MarketType.LENOVO]: `http://market.lenovomm.com/details?id=${QB_PACKAGE_NAME}`,
  [MarketType.YYB]: `tmast://appdetails?pname=${QB_PACKAGE_NAME}`,
};
const getMarketType = () => {
  switch (true) {
    case /huawei/i.test(UA):
      return MarketType.HUAWEI;
    case /honor/i.test(UA):
      return MarketType.HONOR;
    case /oppo|p\w{3}\d{2}/i.test(UA):
      return MarketType.OPPO;
    case /vivo|v\d{4}(a|t)/i.test(UA):
      return MarketType.VIVO;
    case /sm-/i.test(UA):
      return MarketType.SAMSUNG;
    case /\smi\s|\smix\s|\sredmi\s|\sm?\d{4}[0-9a-z]{3,5}cp?\s/i.test(UA):
      return MarketType.XIAOMI;
    case /realme|rmx\d{4}/i.test(UA):
      return MarketType.REALME;
    case /lenovo/i.test(UA):
      return MarketType.LENOVO;
    case /meizu/i.test(UA):
      return MarketType.MEIZU;
    default:
      return MarketType.DEFAULT;
  }
};
const isAndroid = () => {
  return /android/i.test(UA);
};
const isWeixin = () => {
  return /MicroMessenger/i.test(UA);
};

// 小米的需要走特殊换链
const getXiaomiDeepLink = async () => {
  try {
    const res = await window.fetch(
      'https://qbdeeplink.imtt.qq.com/trpc.mtt.qb_app_deeplink.QbAppDeeplink/GetAppDeepLink',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          app_package_name: QB_PACKAGE_NAME,
          sender_package_name: QB_PACKAGE_NAME,
          source: 1,
          type: 1,
          user_base_info: {
            guid: '',
            qimei36: '',
            qua2: '',
          },
        }),
      }
    );
    const data = await res.json();
    // console.log('qbdeeplink result', data);
    if (!data || !data.deep_link_data) return '';
    return data.deep_link_data;
  } catch (e) {
    console.log(e);
    return '';
  }
};

// 主函数 安卓微信场景直接跳应用市场
export const launchApp = async () => {
  // console.log('当前UA头为', UA, isAndroid(), isWeixin());
  if (!isAndroid() || !isWeixin()) return;
  // console.log('安卓微信场景');
  const mkType = getMarketType();
  let schemeUrl = MARKET_SCHEME_MAP[mkType];
  // console.log('当前应用市场为', mkType, schemeUrl);
  if (mkType === MarketType.XIAOMI) {
    schemeUrl = await getXiaomiDeepLink();
  }
  if (!schemeUrl) return;
  window.WeixinJSBridge.invoke(
    'launchApplication',
    {
      schemeUrl: schemeUrl,
    },
    (res) => {
      console.log('launchApplication result', res);
    }
  );
};
